import React from 'react'
import { Card, Row } from 'antd'
import Heading from '../../../component/common/Heading'
import CRUDComponent from '../../../component/common/CRUD-Component'
import CONSTANTS from '../../../util/constant/CONSTANTS'
import { useNavigate, useParams } from 'react-router-dom'
import BackButton from '../../../component/common/Back-Button'

const FeedBackDetail = () => {
    const { id } = useParams()
    const navigate = useNavigate()
    return (
        <>
            <div className='my-5'>
                <Card>
                    <BackButton onClick={() => navigate(-1)} />
                    <Heading>FeedBack Details</Heading>

                    <Row>
                        <CRUDComponent
                            GET={{
                                API: CONSTANTS.API.Feedback.getAll,
                                extraQuery: {
                                    feedbackId: id
                                },
                                DataModifier: (res, API, Setrefresh) => {
                                    // console.log(res, "GET ALL ABCD");
                                    return res?.map(data => {
                                        return {
                                            ...data,
                                            no: `F${data?.id.toString().padStart(7, "0")}`,
                                            user: data?.user?.name || '-',
                                            email: data?.user?.email || '-',
                                            mobile: data?.user?.mobile ? `+${data?.user?.countryCode || ''} ${data?.user?.mobile} ` : '-',
                                            feedback: data?.feedback?.question,
                                            rating: data?.rating ? {
                                                ratings: data?.rating
                                            } : '-',

                                        }
                                    })
                                },
                                column: CONSTANTS.TABLE.FEEDBACK_DETAIL,
                            }}
                            isSearch={true}
                        />
                    </Row>
                </Card>
            </div>


        </>
    )
}

export default FeedBackDetail